import { useEffect, useState } from "react";

import { useDispatch } from 'react-redux';

import { useNavigate } from "react-router";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from "@mui/material"

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";
import { SearchTextField } from "../../components/SearchTextField";

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ActualizarDistritoJudicial, AgregarDistritoJudicial, DistritoJudicial } from "../../connections/catalogos/DistritoJudicialConnection";

import { DistritoJudicialProps } from "../../interfaces/catalogos/DistritoJudicialInterface";

export const DistritoJudicialPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [DistritoJudicialArray, setDistritoJudicialArray] = useState<DistritoJudicialProps[]>( [] );
 
    const [openModal, setOpenModal] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idDistritoJudicial, setIdDistritoJudicial] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( DistritoJudicialArray, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const DistritoJudicialSelected = DistritoJudicialArray.find( ( elem ) => elem.idDistritoJudicial === id );

        if( DistritoJudicialSelected ){

            await ActualizarDistritoJudicial({ ...DistritoJudicialSelected, activo: checked }).then( resp => {
                
                if( resp.idDistritoJudicial ){

                    var newArray = DistritoJudicialArray.map( ( elem ) => {

                    if( elem.idDistritoJudicial === id ){
                        elem.activo = checked;
                    }
            
                        return elem;
                    });
            
                    setDistritoJudicialArray( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));     

                }    
    
            });
        }       

    }

    const handleGuardar = async () => {

        if( idDistritoJudicial !== 0 ){

            const DistritoJudicialSelected = DistritoJudicialArray.find( ( elem ) => elem.idDistritoJudicial === idDistritoJudicial );

            if( DistritoJudicialSelected ){

                setLoading( true );
    
                await ActualizarDistritoJudicial({ ...DistritoJudicialSelected, descripcion, }).then( resp => {
                    
                    if( resp.idDistritoJudicial ){

                        setTimeout(() => {
                            
                            var newArray = DistritoJudicialArray.map( ( elem ) => {
        
                                if( elem.idDistritoJudicial === idDistritoJudicial ){
                                    elem.descripcion = descripcion;
                                }
                        
                                return elem;
                            });
                    
                            setDistritoJudicialArray( newArray );
                            setOpenModal( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));     
                            
                        }, 700);
    
                    }    
        
                });
            }       
    

        }
        else {

            const DistritoJudicialAdd: DistritoJudicialProps = {
                idDistritoJudicial: 0,
                descripcion,               
                activo: true,
            }

            setLoading( true );

            await AgregarDistritoJudicial( DistritoJudicialAdd ).then( resp => {
                    
                if( resp.idDistritoJudicial ){                
            
                    setTimeout(() => {
                        
                        setDistritoJudicialArray([ ...DistritoJudicialArray, resp ]);
                        setOpenModal( false );
                        setLoading( false );
                        
                        dispatch( openSnackbar({ message: 'Se agregó el distrito judicial correctamente', variant: 'success' }));     

                    }, 700);

                }    
    
            });

        }

    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setDistritoJudicialArray( [] );

            await DistritoJudicial().then( resp => {

                setTimeout(() => {
                    
                    setDistritoJudicialArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])    

    return (

        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Distrito judicial' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >  
                
                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    <Button startIcon={ <UndoIcon /> } color="secondary" variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }> 
                        Regresar
                    </Button> 

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button 
                        variant="contained" 
                        sx={{ mt: 1 }} 
                        disabled={ loadingData }
                        onClick={ () => {
                            
                            setIdDistritoJudicial( 0 );
                            setDescripcion( '' );

                            setOpenModal( true );
                        }}
                    > 
                        Agregar
                    </Button> 

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }}>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar por descripción"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%', textAlign: 'center'  }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'75%' }}> Descripción </TableCell>                                     
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ? 
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( { idDistritoJudicial, descripcion, activo } ) => (

                                <TableRow key={ idDistritoJudicial} >
                                
                                    <TableCell sx={{ fontWeight: 'bold', textAlign: 'center'  }}>
                                        { idDistritoJudicial }
                                    </TableCell>                                 

                                    <TableCell>
                                        { descripcion }
                                    </TableCell>      
    
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idDistritoJudicial ) }
                                        />                                            
                              
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {

                                                    setIdDistritoJudicial( idDistritoJudicial );
                                                    setDescripcion( descripcion );                                                   

                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  

                                    </TableCell>

                                </TableRow>

                            ))
                        }                    
            
                        { 
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                                <TableRow>

                                    <TableCell colSpan={1} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell>

                                    <TablePagination
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>
                        }

                    </TableFooter>
                    
                </Table>
                
            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
            
                <DialogContent sx={ DialogContentStyle }>
                       
                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción'}
                        variant="outlined"                           
                        multiline
                        rows={4}                                        
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }} 
                    /> 

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color="secondary" disabled={ loading } onClick={ () => { setOpenModal( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}